import type { HTMLAttributes } from 'react';
import { cn } from './utils';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

export type AvatarProps = HTMLAttributes<HTMLSpanElement> & {
  src?: string;
  /** Fallback initials shown when `src` is missing or fails. */
  initials?: string;
  size?: AvatarSize;
  alt?: string;
};

const SIZE_CLS: Record<AvatarSize, string> = {
  xs: 'w-6 h-6 text-[10px] rounded-md',
  sm: 'w-7 h-7 text-[11px] rounded-md',
  md: 'w-9 h-9 text-[12.5px] rounded-lg',
  lg: 'w-12 h-12 text-[14px] rounded-xl',
};

export function Avatar({
  src,
  initials,
  size = 'sm',
  alt = '',
  className,
  ...rest
}: AvatarProps) {
  return (
    <span
      data-no-media-viewer
      {...rest}
      className={cn(
        'inline-grid place-items-center overflow-hidden bg-ink-100 ring-1 ring-ink-200 text-ink-900 font-semibold shrink-0',
        SIZE_CLS[size],
        className,
      )}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" draggable={false} />
      ) : (
        <span className="leading-none">{initials ?? ''}</span>
      )}
    </span>
  );
}
